export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    navigator.serviceWorker?.addEventListener("message", (event) => {
      if (event.data?.type === "NAVIGATE_TO_URL") {
        // SW の safeOpen は同一オリジンの内部パスを返す。ガード付き遷移を使う。
        void navigateToSafePath(event.data.url, { fallbackMode: "TOP_PAGE" });
      }
    });
  }
});
